/** Structural sharing for the editor's immutable JSON-shaped render data. */
export function shareRenderData<T>(previous: T | undefined, next: T): T {
  if (previous === next) return next;
  if (!previous || !next || typeof previous !== "object" || typeof next !== "object") return next;
  if (Array.isArray(next)) {
    if (!Array.isArray(previous)) return next;
    let equal = previous.length === next.length;
    const shared = next.map((item, index) => {
      const value = shareRenderData(previous[index], item);
      if (value !== previous[index]) equal = false;
      return value;
    });
    return (equal ? previous : shared) as T;
  }
  if (Array.isArray(previous)) return next;
  const oldRecord = previous as Record<string, unknown>;
  const newRecord = next as Record<string, unknown>;
  const keys = Object.keys(newRecord);
  let equal = keys.length === Object.keys(oldRecord).length;
  const shared: Record<string, unknown> = {};
  for (const key of keys) {
    const value = shareRenderData(oldRecord[key], newRecord[key]);
    if (!Object.prototype.hasOwnProperty.call(oldRecord, key) || value !== oldRecord[key])
      equal = false;
    shared[key] = value;
  }
  return equal ? previous : (shared as T);
}
